import { Model } from '@type-r/models'
import { useModel } from '@type-r/react'
import { useRef } from 'react'

/**
 * Barrel module for shared application UI components and related model definitions.
 */
export * from './angularReactPage'
export * from './attachments'
export * from './collapsableAddress'
export * from './components'
export * from './identifers'
export * from './inmatch'
export * from './modelsDiff'
export * from './shipment'
export * from './shipping'

// Synchronous version of the useModelCopy hook.
// Silently updates the model, skips update if the parent token is the same as the copy,
// which prevents the extra sync when the parent is synched back.
// It caused the bug as the collection items without ids cannot be synced properly.
// TODO: Move it to the Type-R.
export function useModelCopySync( model : Model ) {
    const local = useModel( (model as any).constructor);
    const lastMasterToken = useRef( null );

    if( model['_changeToken'] !== lastMasterToken.current ){
        if( local['_changeToken'] !== model['_changeToken'] ){
            local.set( model[ '__inner_state__' ], { merge: true, silent : true });
            local['_changeToken'] = model['_changeToken'];
        }

        lastMasterToken.current = model['_changeToken'];
    }

    return local;
}